// Core lib dependencies.
import React from 'react';
import PropTypes from 'prop-types';

// Component dependencies.
import { Button } from '../../../common/components/buttons.jsx';

/**
 * PrivacySettingsButton React component.
 *
 * Display a button which will open the privacy management consent popup dialog when clicked.
 *
 * @memberof module:PrivacyManagement.Components
 * @namespace
 *
 * @return {PrivacyManagement.Components.PrivacySettingsButton}
 */
const PrivacySettingsButton = (props) => {
  if (!props.isVisible) {
    return null;
  }

  return (
    <div className="xPrivacy_settingsButton xButton xCTA">
      <Button
        className="xSettingsButtonLink"
        ariaLabel={NGX.lang.privacy.settings.tooltip}
        title={NGX.lang.privacy.settings.tooltip}
        onClick={props.onClick}
      >
        {NGX.lang.privacy.settings.text}
      </Button>
    </div>
  );
};

/**
 * React PropTypes.
 *
 * @type {Object}
 * @property {Boolean} isVisible Should we show the privacy settings button
 * @property {Function} onClick Function to call when handling the button click
 */
PrivacySettingsButton.propTypes = {
  isVisible: PropTypes.bool,
  onClick:   PropTypes.func,
};

PrivacySettingsButton.defaultProps = {
  isVisible: false,
  onClick:   () => {},
};

export default PrivacySettingsButton;
